export const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return ''; // Date invalide
        
        // Format YYYY-MM-DD
        return date.toISOString().split('T')[0];
    } catch (e) {
        console.error('Erreur de format de date:', e);
        return '';
    }
};

/**
 * Formate une date au format DD/MM/YYYY (format français)
 * @param {string} dateString - La date à formater
 * @returns {string} - La date formatée ou une chaîne vide si la date est invalide
 */
export const formatDateFR = (dateString) => {
    if (!dateString) return '';
    
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return ''; // Date invalide
        
        // Format DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}/${month}/${year}`;
    } catch (e) {
        console.error('Erreur de format de date:', e);
        return '';
    }
};

/**
 * Calcule l'âge d'une personne à partir de sa date de naissance
 * @param {string} birthDateString - La date de naissance
 * @returns {number} - L'âge calculé ou -1 si la date est invalide
 */
export const calculateAge = (birthDateString) => {
    if (!birthDateString) return -1;
    
    try {
        const birthDate = new Date(birthDateString);
        if (isNaN(birthDate.getTime())) return -1; // Date invalide
        
        const today = new Date();
        
        // Calcul de l'âge
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        // Ajustement si le mois de naissance n'est pas encore passé cette année
        // ou si c'est le même mois mais que le jour n'est pas encore passé
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        
        return age;
    } catch (e) {
        console.error('Erreur de calcul d\'âge:', e);
        return -1;
    }
};

/**
 * Vérifie si une personne est mineure à partir de sa date de naissance
 * @param {string} birthDateString - La date de naissance
 * @returns {boolean} - true si la personne est mineure, false sinon ou si la date est invalide
 */
export const isMinor = (birthDateString) => {
    const age = calculateAge(birthDateString);
    return age >= 0 && age < 18;
};

/**
 * Ajoute un nombre spécifié de jours à une date
 * @param {Date|string} date - La date de départ
 * @param {number} days - Le nombre de jours à ajouter (peut être négatif)
 * @returns {Date} - La nouvelle date
 */
export const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

/**
 * Calcule la différence en jours entre deux dates
 * @param {Date|string} date1 - Première date
 * @param {Date|string} date2 - Deuxième date
 * @returns {number} - Nombre de jours de différence (valeur absolue)
 */
export const daysBetween = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    
    // Convertir en jours et arrondir
    const diffTime = Math.abs(d2 - d1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
};